import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemSliderComponent } from './item-slider.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ItemSliderComponent],
  exports: [ItemSliderComponent]
})
export class ItemSliderModule { }



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/item-slider/item-slider.module.ts